import promiseMiddleware from 'redux-promise-middleware';
import thunkMiddleware from 'redux-thunk';
import {
  legacy_createStore as createStore,
  applyMiddleware,
  compose,
  Middleware,
  StoreEnhancer,
} from 'redux';
import { getFirebase } from 'react-redux-firebase';
import { responsiveStoreEnhancer } from 'redux-responsive';
import { createWrapper, Context, HYDRATE } from 'next-redux-wrapper';

import app, { auth } from '../Firebase';
import createRootReducer from '../reducers';

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }
}

const composeEnhancers =
  (process.env.NODE_ENV === 'development' &&
    typeof window !== 'undefined' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;

const rrfConfig = {
  userProfile: 'users',
  enableRedirectHandling: false,
  resetBeforeLogin: false,
};

const enhancer = composeEnhancers(
  responsiveStoreEnhancer,
  applyMiddleware(
    thunkMiddleware.withExtraArgument(getFirebase),
    promiseMiddleware as Middleware,
  ),
) as StoreEnhancer;

// create a makeStore function
const makeStore = (context: Context) =>
  createStore(createRootReducer, enhancer);

// export an assembled wrapper
export const wrapper = createWrapper(makeStore, { debug: false });

// Export rrfProps for ReactReduxFirebaseProvider
export const rrfProps = {
  firebase: app,
  config: rrfConfig,
  dispatch: null as any, // Will be set by the provider
  createFirestoreInstance: undefined, // Not using Firestore
};

